// Generic card filter for both PeoplePage and ArticleList
// Supports:
// - PeoplePage: .js-card-tag-filter, .js-card-competency-filter, .js-card-filter, data-filter, "Alle"
// - ArticleList: #kompetanse, .js-card-filter, data-category, "alle"
// Note: Only targets containers with .js-card-filter class to avoid affecting other pages like Search

// Initialize function - can be called immediately or on DOMContentLoaded
function initCardFilter() {
	// Cache DOM queries - only query once
	const tagFilter = document.querySelector(".js-card-tag-filter");
	const peopleCompetencyFilter = document.querySelector(
		".js-card-competency-filter"
	);
	const kompetanseFilter = document.getElementById("kompetanse");

	// Determine which filters exist
	const primaryFilter = tagFilter;
	const competencyFilter = peopleCompetencyFilter || kompetanseFilter;

	// Find cards container - only target containers with js-card-filter hook
	// This prevents the filter script from affecting cards on pages like Search
	const cardsContainer = document.querySelector(".js-card-filter");
	if (!cardsContainer) return;

	const cards = cardsContainer.querySelectorAll(".card");

	// If no filters found at all, exit early
	if (!primaryFilter && !competencyFilter) return;

	// Determine filter type based on which selectors were found (cache this)
	const isPeoplePage = tagFilter !== null;
	const isArticleList = !isPeoplePage && kompetanseFilter !== null;

	// Determine "all" value based on page type
	const allValue = isPeoplePage ? "Alle" : "alle";

	// Cache search inputs to avoid repeated DOM queries
	const searchInputs = document.querySelectorAll(".js-card-search");

	// Pre-process card data for better performance
	// Cache parsed filter data to avoid repeated string operations
	const cardData = Array.from(cards).map((card) => {
		const data = {
			element: card,
			// Cache primary filter data - only read if primaryFilter exists
			filterAttr: primaryFilter
				? isPeoplePage
					? card.getAttribute("data-filter") || ""
					: card.getAttribute("data-category") || ""
				: "",
			// Cache and pre-parse competency data
			competencyAttr: card.getAttribute("data-competency") || "",
			competencyArray: null, // Will be parsed on-demand
		};

		// Pre-parse competency if it exists (most cards will have this)
		if (data.competencyAttr) {
			data.competencyArray = data.competencyAttr
				.split(",")
				.map((c) => c.trim())
				.filter((c) => c !== "")
				.map((c) => c.toLowerCase()); // Normalize to lowercase once
		}

		// Pre-parse filter tags for PeoplePage
		if (isPeoplePage && data.filterAttr) {
			data.filterArray = data.filterAttr
				.split(/\s+/)
				.filter((f) => f.trim() !== "");
		}

		return data;
	});

	const filterCards = function () {
		const selectedPrimary = primaryFilter ? primaryFilter.value : allValue;
		const selectedCompetency = competencyFilter
			? competencyFilter.value.toLowerCase()
			: "alle";

		// Normalize selectedPrimary once
		const normalizedPrimary =
			selectedPrimary === allValue ? null : selectedPrimary;
		const normalizedCompetency =
			selectedCompetency === "alle" ? null : selectedCompetency;

		// Batch DOM operations using DocumentFragment or requestAnimationFrame
		// For better performance, we'll use a flag-based approach
		cardData.forEach((data) => {
			const card = data.element;

			// Check primary filter (tag/category) - only if primaryFilter exists
			let showByPrimary = true; // Default to true if no primary filter
			if (primaryFilter && normalizedPrimary !== null) {
				if (isPeoplePage) {
					// PeoplePage: uses pre-parsed filterArray
					showByPrimary =
						data.filterArray && data.filterArray.includes(normalizedPrimary);
				} else {
					// ArticleList: uses data-category with single value
					showByPrimary = data.filterAttr === normalizedPrimary;
				}
			}

			// Check competency filter
			let showByCompetency = true;
			if (normalizedCompetency !== null) {
				if (data.competencyArray) {
					// Use pre-parsed, normalized array
					showByCompetency =
						data.competencyArray.includes(normalizedCompetency);
				} else {
					showByCompetency = false;
				}
			}

			// Show card only if it passes both filters
			const shouldShow = showByPrimary && showByCompetency;

			if (isPeoplePage) {
				// PeoplePage: use CSS classes - batch operations
				if (shouldShow) {
					card.classList.remove("hide");
					card.classList.add("show");
				} else {
					card.classList.add("hide");
					card.classList.remove("show");
				}
			} else {
				// ArticleList: use inline display style
				card.style.display = shouldShow ? "" : "none";
			}
		});
	};

	// Clear filters function
	const clearFilters = function () {
		if (primaryFilter) {
			primaryFilter.value = allValue;
		}
		if (competencyFilter) {
			competencyFilter.value = "alle";
		}

		// Clear search input fields (using cached reference)
		searchInputs.forEach((searchInput) => {
			searchInput.value = "";
			// Trigger input event to restore visibility in card-search.js
			searchInput.dispatchEvent(new Event("input", { bubbles: true }));
		});

		filterCards();
	};

	// Initialize filter on page load (show all cards by default)
	filterCards();

	// Listen for changes on both selects
	if (primaryFilter) {
		primaryFilter.addEventListener("change", filterCards);
	}
	if (competencyFilter) {
		competencyFilter.addEventListener("change", filterCards);
	}

	// Add clear filters button functionality
	const clearFiltersButton = document.querySelector(".js-clear-filters");
	if (clearFiltersButton) {
		clearFiltersButton.addEventListener("click", function (e) {
			e.preventDefault();
			clearFilters();
		});
	}
}

// Check if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCardFilter);
} else {
	// DOM is already loaded, run immediately
	initCardFilter();
}
